export const version = "1.42.1";
